import {AbstractViewerComponent} from "./abstract-viewer.component";
import {customElement} from "lit/decorators/custom-element.js";
import {DateHelper} from "../../helpers/date.helper";
import {PropertyValues} from "@lit/reactive-element";

@customElement('ha-timespan-viewer')
export class HaTimespanViewerComponent extends AbstractViewerComponent<number> {

    protected shouldUpdate(_changedProperties: PropertyValues): boolean {
        return typeof this.value == "number" && super.shouldUpdate(_changedProperties);
    }

    protected render(): unknown {
        return DateHelper.convertDurationToString(this.value as number);
    }
}